import React from 'react';
import { useQuery } from '@tanstack/react-query';
import NotificationDropdown from './NotificationDropdown';
import { fetchUnreadNotifications } from '../../apis/NotificationsApi';
import { FaBell } from "react-icons/fa";
import './NotificationBell.css';

export default function NotificationBell({ userId }) {
  const [open, setOpen] = React.useState(false);

  const { data: unreadData = { data: [] }, refetch } = useQuery({
    queryKey: ['unreadNotifications', userId],
    queryFn: () => fetchUnreadNotifications(userId, 1, 100)
  });

  const unreadCount = unreadData.data ? unreadData.data.length : 0;

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(!open)}
        className='notification-bell'
      >
        <FaBell size={18} style={{color: 'rgb(67, 5, 68)'}}/>
        {unreadCount > 0 && (
          <span className='unread-badge'>
            {unreadCount}
          </span>
        )}
      </button>

      {open && (
        <NotificationDropdown userId={userId} onClose={() => setOpen(false)} onUpdate={refetch} />
      )}
    </div>
  );
}
